import { useEffect } from "react";
import { useInView } from "react-intersection-observer";
import type { Lodging } from "@b2bportal/lodging-api";
import {
  HotelsRawEventName,
  useEmitCoreHotelsRawEventOnce,
} from "../../../tracking";

type UseHotelCardTrackingParams = {
  hotel: Lodging;
  threshold?: number[];
  delay?: number;
};

export const useHotelCardTracking = ({
  hotel,
  // By default, emit the event when 50% of the card becomes visible
  threshold = [0.5],
  // also default delaying by 1000ms since user may scroll fast through the list
  delay = 1000,
}: UseHotelCardTrackingParams) => {
  const { ref, inView } = useInView({ threshold, delay, triggerOnce: true });

  useEmitCoreHotelsRawEventOnce(
    {
      name: HotelsRawEventName.HotelViewedLodgingInList,
      properties: {
        hotelId: hotel.lodging.id,
      },
    },
    inView && hotel != null
  );

  return { ref };
};
